import API from '../api';
import WhitelabelView from '../models/view/WhitelabelView';
import api from '../api';

export default () => ({
    read(subdomain) {
        return api
            .get(`/api/account/whitelabeling/${subdomain}`, false)
            .then(response => API.handle(response))
            .catch(API.error)
            .then(json => new WhitelabelView(json));
    },
});
